import { Computer } from "lucide-react";

import { cn } from "@/lib/utils";
import { MARKER_COLOR } from "components/CaseMap/mapLayers";

/**
 * A single machine's pin. Selection is the only state encoded here — approval
 * status is deliberately not colour-coded, per the ticket's design notes.
 */
export function MachineMarkerPin({ selected }) {
  const color = selected ? MARKER_COLOR.selectedMachine : MARKER_COLOR.machine;

  return (
    <div className="tw:flex tw:flex-col tw:items-center tw:drop-shadow-md">
      <div
        className={cn(
          "tw:flex tw:size-8 tw:items-center tw:justify-center tw:rounded-full tw:text-white tw:ring-2 tw:ring-white tw:transition-transform tw:hover:scale-110",
          selected && "tw:scale-110 tw:ring-3"
        )}
        style={{ backgroundColor: color }}
      >
        <Computer className="tw:size-4" />
      </div>
      <div
        className="tw:-mt-px tw:size-0 tw:border-x-[5px] tw:border-t-[7px] tw:border-x-transparent"
        style={{ borderTopColor: color }}
      />
    </div>
  );
}
